<template>
    <div>
        <avue-crud :data="data" :option="option" :page.sync="page" :search.sync="search"  @selection-change="selectionChange" @current-change="changePage" @search-change="searchChange" @search-reset="resetChange">
            <template slot="menuBtn" slot-scope="scope">
                <el-dropdown-item  class="pull-down" @click.native="signBtn(scope.row)"  v-loading.fullscreen.lock="fullscreenLoading" v-if="scope.row.is_sign==1">签署</el-dropdown-item>
                <el-dropdown-item  class="pull-down" @click.native="revocationBtn(scope.row)" v-if="scope.row.is_faqiren==1">作废</el-dropdown-item>
                <el-dropdown-item  class="pull-down" @click.native="viewBtn(scope.row)" >查看</el-dropdown-item>
            </template>
            <template slot="menuLeft"  slot-scope="scope" >
                <el-button  class="View" @click="submitBtn">批量签署</el-button>
            </template>
            <template slot="doc_title" slot-scope="scope" >
                <el-tooltip :content="scope.row.doc_title" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.doc_title }}</p>
                </el-tooltip>
            </template>
            <template slot="system_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.system_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.system_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="contract_sn" slot-scope="scope" >
                <el-tooltip :content="scope.row.contract_sn" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.contract_sn }}</p>
                </el-tooltip>
            </template>
            <template slot="all_signers" slot-scope="scope" >
                <el-tooltip :content="scope.row.all_signers" class="item" effect="dark" placement="bottom">
                    <p class="textStyle">{{ scope.row.all_signers }}</p>
                </el-tooltip>
            </template>
        </avue-crud>
        <!--        作废-->
        <el-dialog
                title="提示"
                :visible.sync="dialogVisible"
                :close-on-click-modal="false"
                width="30%">
            <span>请确认是否要作废该合同</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmBtn">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        batchSigning,
        contractList,
        contractSearch,
        revocationContract,
        uponMySignature
    } from '../../../api/contract';

    export default {
        name: "waitMe",
        inject: ['reload'],
        data() {
            return {
                page: {
                    currentPage: 1,
                    total: 20,  //总数
                    pageSize: 10, //每页多少
                    // pagerCount:5
                },
                data: [],
                search:{
                    doc_title:'',
                    all_signers:'',
                    begin_time:'',
                    end_time:'',
                },
                dialogVisible:false,
                doc_title:'',
                all_signers:'',
                begin_time:'',
                end_time:'',
                pages:1,
                fullscreenLoading:false, //loading加载
                option:{
                    menuType: 'menu',
                    menuBtnTitle:'操作',
                    selection: true, //批量选择
                    align:'center',
                    menuAlign:'center',
                    editBtn:false,
                    delBtn:false,
                    menuWidth:150,//操作栏宽度设置
                    rowKey:'ids',
                    refreshBtn: false, //刷新按钮
                    columnBtn: false, //表格右侧操作列显隐的按钮
                    addBtn:false, //左上角新增
                    column:[
                        {
                            label:'合同名称',
                            prop:'doc_title',
                            search:true
                        }, {
                            label:'平台编号',
                            prop:'system_sn',
                        },
                        // {
                        //     label:'合同编号',
                        //     prop:'contract_sn',
                        // },
                        {
                            label:'发起人',
                            prop:'faqi_ren'
                        },  {
                            label:'发起时间',
                            prop:'faqi_time',
                            type: "datetime",//使用的组件类型
                            search: true,//是否可以搜索
                            searchRange: true,//控制搜索时是否是日期范围默认为false是单独的一天
                            valueFormat: "yyyy-MM-dd HH:mm:ss",
                            searchDefaultTime: ["00:00:00", "23:59:59"], //搜索框的默认时分秒设置
                        },  {
                            label:'参与人',
                            prop:'all_signers',
                            width:'500',
                            search: true
                        },  {
                            label:'合同状态',
                            prop:'ct_status_txt'
                        },  {
                            label: '签署截止时间',
                            prop: 'expire_time'
                        }

                    ]
                },
            };
        },
        methods:{
            //分页
            changePage(num){
                if (this.doc_title==''&&this.all_signers==''){
                    contractList(3,10,num).then(res=>{
                        sessionStorage.setItem('waitMe',num)
                        this.data=res.data.list
                        this.page.total=res.data.count
                    })
                }else {
                    //搜索后分页
                    contractSearch(3,10,num,this.doc_title,this.all_signers).then(res=>{
                        if (res.code==200){
                            sessionStorage.setItem('waitMeSearch', num)
                            this.data=res.data.list
                            this.page.total=res.data.count
                        }
                    })
                }
            },
            //搜索
            searchChange(from,done){
                this.doc_title=from.doc_title
                this.all_signers=from.all_signers
                if (from.faqi_time!==undefined){
                    this.begin_time=from.faqi_time[0]
                    this.end_time=from.faqi_time[1]
                }else{
                    this.begin_time=''
                    this.end_time=''
                }
                contractSearch(3,10,1,from.doc_title,from.all_signers,this.begin_time,this.end_time).then(res=>{
                    if (res.code==200){
                        sessionStorage.setItem('waitMeSearch', 1)
                        sessionStorage.setItem('waitMeParams', JSON.stringify(from) )
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                    }
                })
                done()
            },
            //重置搜索
            resetChange(){
                this.doc_title=''
                this.all_signers=''
                this.begin_time=''
                this.end_time=''
                contractList(3,10,this.pages).then(res=>{
                    if (res.code==200){
                        sessionStorage.removeItem('waitMe')
                        sessionStorage.removeItem('waitMeSearch')
                        sessionStorage.removeItem('waitMeParams')
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                        this.$message.success('重置成功')
                    }

                })
            },
            //签署
            signBtn(row){
                this.fullscreenLoading=true
                uponMySignature(row.id).then(res=>{
                    if (res.code==200){
                        this.fullscreenLoading=false
                        const link = document.createElement("a"); //自己创建的a标签
                        link.href = res.data.sign_url+'?v='+Math.random();
                        link.target="_blank"
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        window.URL.revokeObjectURL(res.data.sign_url);
                    }else {
                        this.fullscreenLoading=false
                        this.$message.error(res.msg)
                    }
                })
            },
            //批量操作
            selectionChange(list){
                this.ids = []
                list.forEach(res=>{
                    this.ids.push(res.id)
                })
            },
            //批量签署
            submitBtn(){
                if (this.ids==undefined||this.ids==''){
                    this.$message.error('请选择要签署的合同');
                    return
                }else {
                    batchSigning(this.ids).then(res=>{
                        if (res.code==200){
                            const link = document.createElement("a"); //自己创建的a标签
                            link.href = res.data.sign_url+'?v='+Math.random();
                            // link.target="_blank"
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(res.data.sign_url);
                        }else {
                            this.$message.error(res.msg);
                        }
                    })
                }

            },
            //作废
            revocationBtn(row){
                this.dialogVisible=true
                this.id=row.id

            },
            //确认作废
            confirmBtn(){
                revocationContract(this.id).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg);
                        this.reload()
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            },
            //查看
            viewBtn(row){
                this.$router.push({path:'/detailsPage',query:{id:row.id}})
            }
        },
        created() {
            if (sessionStorage.getItem('waitMeSearch')){
                let waitMeParams=JSON.parse(sessionStorage.getItem('waitMeParams'))
                this.search=waitMeParams
                this.doc_title=waitMeParams.doc_title
                this.all_signers=waitMeParams.all_signers
                if (waitMeParams.faqi_time!==undefined){
                    this.begin_time=waitMeParams.faqi_time[0]
                    this.end_time=waitMeParams.faqi_time[1]
                }else{
                    this.begin_time=''
                    this.end_time=''
                }
                contractSearch(3,10,sessionStorage.getItem('waitMeSearch'),this.doc_title,this.all_signers,this.begin_time,this.end_time).then(res=>{
                    if (res.code==200){
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=sessionStorage.getItem('waitMeSearch')
                    }
                })
            }else {
                if (sessionStorage.getItem('waitMe')===null){
                    contractList(3,10,this.pages).then(res=>{
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=1
                    })
                }else {
                    contractList(3,10,sessionStorage.getItem('waitMe')).then(res=>{
                        this.data=res.data.list
                        this.page.total=res.data.count
                        this.page.currentPage=sessionStorage.getItem('waitMe')
                    })
                }
            }

        }
    }
</script>

<style scoped>
    /deep/.el-col{
        width: 25%;
    }
    /deep/.avue-form__menu{
        padding: 0px;
    }
    /deep/ .el-tabs__active-bar{
        background-color: #3d62f6;
    }
    .View{
        background: #3d62f6;
        color: #fff;
    }
    /deep/.el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }
    /deep/.el-icon-arrow-down {
        font-size: 15px;
    }
    .pull-down{
        padding: 5px 30px !important;
    }
    .textStyle{
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        cursor: default;
        margin:0;
    }
</style>
